import type {RouteRecordRaw} from "vue-router";
import {EPermissao} from "@/core/type/permissao.type";

export const cteRoutes: RouteRecordRaw[] = [
    {
        path: "/cte",
        name: "cte",
        meta: {authRequired: true, permissao: EPermissao.CGR_PRISMA_CONSULTAR_DFE_CTE},
        component: () => import("@/modules/cte/pages/PageCte.vue")
    },
];
